import React, { useState, useEffect } from 'react'
import { Tooltip, Tabs } from 'antd'
import { Params } from './Params'
import { Config } from './config'
import { Imports } from './Imports'
import { Permissions } from './Permissions'
import { IState, useCreateFunction, setState } from '../CreateFunctionContext'

// icons
import { ReactComponent as FolderIcon } from '../../../../../assets/svg/MarketplaceFunctions/Folder_alt_duotone_fill.svg'
import { ReactComponent as FolderDarkIcon } from '../../../../../assets/svg/MarketplaceFunctions/Folder_alt_duotone_fill_s.svg'
import { ReactComponent as ConfigIcon } from '../../../../../assets/svg/MarketplaceFunctions/Structure.svg'
import { ReactComponent as ConfigDarkIcon } from '../../../../../assets/svg/MarketplaceFunctions/Structure_s.svg'
import { ReactComponent as ImportIcon } from '../../../../../assets/svg/MarketplaceFunctions/imports.svg'
import { ReactComponent as ImportDarkIcon } from '../../../../../assets/svg/MarketplaceFunctions/import_s.svg'
import { ReactComponent as PermissionsIcon } from '../../../../../assets/svg/MarketplaceFunctions/File_dock_search.svg'
import { ReactComponent as PermissionsDarkIcon } from '../../../../../assets/svg/MarketplaceFunctions/File_dock_search_s.svg'

const { TabPane } = Tabs

export const Sidebar: React.FC<{ state?: IState }> = (props) => {
  const { state } = props
  const [activeTab, setActiveTab] = useState('params')
  const { dispatch } = useCreateFunction()

  const tabs = [
    {
      title: 'Add Params',
      key: 'params',
      icons: [FolderIcon, FolderDarkIcon],
      component: Params,
    },
    {
      title: 'Add Config',
      key: 'config',
      icons: [ConfigIcon, ConfigDarkIcon],
      component: Config,
    },
    {
      title: 'Add Imports',
      key: 'imports',
      icons: [ImportIcon, ImportDarkIcon],
      component: Imports,
    },
    {
      title: 'Add Permission',
      key: 'permissions',
      icons: [PermissionsIcon, PermissionsDarkIcon],
      component: Permissions,
    },
  ]

  useEffect(() => {
    if(state && state.metadata.id) {
      dispatch(setState(state))
    }
  }, [state, dispatch])

  return (
    <div className="mp-func-sidebar">
      <Tabs defaultActiveKey={activeTab} onChange={setActiveTab}>
        {tabs.map((tab) => {
          const { component: Component, title, key, icons } = tab
          const [TabIcon, TabActiveIcon] = icons
          return (
            <TabPane
              key={key}
              tab={
                <BottomTooltip title={title}>
                  {activeTab === key ? <TabActiveIcon /> : <TabIcon />}
                </BottomTooltip>
              }
            >
              <Component />
            </TabPane>
          )
        })}
      </Tabs>
    </div>
  )
}

interface IBottomTooltip {
  children: React.ReactNode
  title: string
}

const BottomTooltip: React.FC<IBottomTooltip> = (props) => {
  const { children, title } = props

  return (
    <Tooltip title={title} placement="bottom">
      {children}
    </Tooltip>
  )
}
